import React, { Component } from "react";
import PageLayout from "../../components/PageLayout";
import FlightPlanKmlViewer from "./FlightPlanKmlViewer";
import NavBar from "../../NavBar/NavBar";

import {
  getSiteById,
  getFlightPlanById,
  FlightPlan,
} from "../../../redux/modules/sites/reducer";

import { connect } from "react-redux";
import { style } from "typestyle";

import { fetchFlightPlan } from "./fetchFlightPlan";
import { GlobalState } from "../../../redux/modules/rootReducer";
import { AppDispatch } from "../../../store";
import { fetchSite, SiteBoundary } from "../../../apiFacades/csu/site";

type Props = {
  customerId: string;
  siteId: string;
  flightPlan: FlightPlan;
  dispatch: AppDispatch;
};

type State = {
  data: Data | null;
};

type Data = {
  siteBoundary: SiteBoundary;
  siteName: string;
  fixedWingKml: string;
  quadcopterKml: string;
};

class FlightPlanPage extends Component<Props, State> {
  state: State = {
    data: null,
  };

  async componentDidMount() {
    const { customerId, siteId, dispatch } = this.props;

    const { boundary, name } = await dispatch(fetchSite(customerId, siteId));

    const { fixedWingKml, quadcopterKml } = await dispatch(
      fetchFlightPlan(customerId, siteId),
    );

    this.setState({
      data: {
        siteBoundary: boundary,
        siteName: name,
        fixedWingKml,
        quadcopterKml,
      },
    });
  }

  render() {
    if (this.state.data === null) {
      return null;
    }

    const {
      siteBoundary,
      siteName,
      fixedWingKml,
      quadcopterKml,
    } = this.state.data;

    return (
      <PageLayout
        navBar={<NavBar />}
        content={
          <div
            className={style({
              padding: "24px",
              paddingTop: "32px",
              borderRadius: "12px",
              boxShadow:
                "0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)",
              background: "#fff",
            })}
          >
            <FlightPlanKmlViewer
              quadcopterKml={quadcopterKml}
              fixedWingKml={fixedWingKml}
              siteName={siteName}
              siteBoundary={siteBoundary}
            />
          </div>
        }
      />
    );
  }
}

interface IOwnProps {
  customerId: string;
  siteId: string;
}

const mapStateToProps = (state: GlobalState, ownProps: IOwnProps) => {
  const { customerId, siteId } = ownProps;
  return {
    site: getSiteById(state.sites, customerId, siteId),
    flightPlan: getFlightPlanById(state.sites, customerId, siteId),
  };
};

export default connect(mapStateToProps)(FlightPlanPage);
